// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import styles from './ActionsBlock.scss';

export type Props = {
  onClickToSetup: void | ((evt: SyntheticMouseEvent<>) => mixed),
  disabled: boolean,
  canChangeSetup: boolean,
  driveUserToSetup: boolean,
};

export default function ActionsBlock({
  onClickToSetup,
  disabled,
  canChangeSetup,
  driveUserToSetup,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <div className={styles.container}>
      {canChangeSetup && !driveUserToSetup && (
        <Button
          type="button"
          disabled={disabled}
          onClick={onClickToSetup}
          kind="outline"
        >
          {__('View Setup')}
        </Button>
      )}
    </div>
  );
}
